export default "__VITE_ASSET__ZwajCaLq__"